import React from 'react';
import '../applications-css/Application.css'
import '../applications-css/PokemonFinder.css'

class PokemonFinder extends React.Component  {
    constructor(props) {
        super(props);
        this.componentDidMount = this.componentDidMount.bind(this);
    }

    componentDidMount() {
        var input = this.refs.inputPokemon;
        input.addEventListener("keyup", this.enterHandler);
      }

      componentWillUnmount() {
        var input = this.refs.inputPokemon;
        input.removeEventListener("keyup", this.enterHandler);
      }

      enterHandler = (e) => {
        if(e.keyCode === 13) {
          this.pokemonSearch();
        }
      }

    pokemonSearch() {
        let request = new XMLHttpRequest();
        let pokemon = this.refs.inputPokemon.value.toLowerCase();
        let url = 'https://pokeapi.co/api/v2/pokemon/' + pokemon;
        request.open('GET', url, true);
        request.onload = function() {
            let spriteURL = null;
            if(request.status >= 200 && request.status < 400) {
                let data = JSON.parse(this.response);
                spriteURL = data.sprites.front_default;
            }
            let img = document.getElementById('sprite');
            img.src = spriteURL;
        }
        request.send();
    }

    render() {
        return(
            <div className="outsideWrapper">
                <div id="pokemonFinderHeader">
                    <input id="pokemonInputField" type="text" ref="inputPokemon"
                      data-testid="input-field"
                      spellCheck="false" rows="1" autoFocus>
                    </input>
                    <button data-testid="button" onClick = {() => this.pokemonSearch()}> Find Pokemon </button>
                </div>
                <div id="pokemonFinderSprite">
                  <img src="" id="sprite" alt="" data-testid="pokemon-img"></img>
                </div>
            </div>
        )
    }
}

export default PokemonFinder;
